import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class SpinnerHelper {
    static loaderStatus: BehaviorSubject<string> = new BehaviorSubject<string>('none');
    static loaderText: BehaviorSubject<string> = new BehaviorSubject<string>('');
    static manualText: boolean = false;

    static displayLoader(value: boolean, text: string = '') {
      const prop = value ? 'block' : 'none';
      SpinnerHelper.loaderStatus.next(prop);
  
      if (value && text) {
        SpinnerHelper.loaderText.next(text);
        SpinnerHelper.manualText = true; // Mark text as manual
      } else if (!value) {
        SpinnerHelper.manualText = false; // Resets markup when hiding spinner
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/spinner/spinner.helper.ts